<div class="page_group">
  <!-- <div>{{state.list}}</div> -->
    <div class="group">
      <div class="tabHeader">
        <div class="select-block">
          <Select :options="state.options" @onChange="selectChange" v-model:selected="state.selectVal"></Select>
        </div>
        <div class="buttonGroup">
          
          <Button type="full" colors="dark1"  theme="2" wd="ssmd"  h="mlg" class="btn-inline" @onClick="openModalCreate" :text="t('__g3p_m8t.__createGroup')"  ></Button>
          <ActionBar class="actionBar" @actionBarClick="actionBarClick" :iconList="state.iconList"></ActionBar>
          <!-- <Button type="full" class="btn-inline" text="Disband" colors="dark1" theme="2" h="mlg" ></Button> -->
          <Dropdown id="drop1" :text="t('__g3p_m8t.__disband')" icon="" popup_x="-148" popup_y="5" :disable="state.list.length?  false:true"
          :data_up="unbindOp" @onClickIndex="dropdownList" >
          </Dropdown>
        </div>
      </div>
    
      <div class="tabMainBlock" :class="{'flexGrowHight': !state.dataList.length }">
        <Table @tableSort="tableSort"  :hasContextmenu="true" @goTableLink="goTableLink" @onCheckAll="onCheckAll" 
          @showCTAndRow="showCTAndRow" @onCheckEach="onCheckEach"
          :columns="column" :data="state.dataList" tablePadding="20" :checkBox="true">
          <template #contextMenu="{position}">
            <CTmenu @selectContextMenu="selectCT" :list="state.ctList" :position="position"></CTmenu>
          </template>
          <template #empty="{text}">
            <div class="Nodata">{{t('__d4e_m8t.__emptyPage')}}</div>
          </template>
        </Table>
      </div>
    </div>
    <!-- <div>
      {{state.meta}} 
    </div> -->
  


  <div class="tabFooter" >
    <Pagination :totalPage="state.meta.total_page" :input="true" position="start" :nowPage="state.meta.current" :range="5" @changePage="changePage"></Pagination>
  </div>



</div>